export const FORM_LAYOUT = {
  form: {
    className: "shadow-sm border-default-200",
  },
  header: {
    className:
      "p-6 bg-gradient-to-r from-primary-50 to-default-50 border-b border-default-200 flex items-center gap-3",
    description: "text-sm text-default-500",
    title: "text-lg font-medium text-default-900",
  },
  padding: {
    buttonGroup: "mt-8",
    section: "mb-8",
  },
  spacing: {
    betweenFields: "space-y-4",
    betweenSections: "space-y-6",
    buttonGroup: "space-x-3",
  },
} as const;
